import React, { useState } from "react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import { toast } from "sonner";
import { MapPin, Mail, Phone } from "lucide-react";
import { api } from "../lib/api";
import { SocialLinks } from "../components/Layout";

export default function Contact() {
  const [f, setF] = useState({ name: "", email: "", subject: "General inquiry", message: "" });
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/contact", f); toast.success("Message received. We'll reply within one business day."); setF({ name: "", email: "", subject: "General inquiry", message: "" }); }
    catch { toast.error("Could not send message"); }
  };
  return (
    <div data-testid="contact-page" className="max-w-6xl mx-auto px-6 lg:px-10 py-16">
      <div className="uppercase text-xs tracking-[0.3em] font-bold" style={{color: "var(--secondary)"}}>Contact</div>
      <h1 className="font-serif text-5xl sm:text-6xl mt-3 leading-none" style={{color: "var(--primary)"}}>Say hello. We're listening.</h1>
      <div className="mt-10 grid lg:grid-cols-2 gap-12">
        <form onSubmit={submit} data-testid="contact-form" className="bg-white rounded-lg border hairline p-8 space-y-5">
          <div><Label>Your name</Label><Input data-testid="contact-name" required value={f.name} onChange={(e) => setF({...f, name: e.target.value})}/></div>
          <div><Label>Email</Label><Input data-testid="contact-email" type="email" required value={f.email} onChange={(e) => setF({...f, email: e.target.value})}/></div>
          <div><Label>Subject</Label><Input data-testid="contact-subject" value={f.subject} onChange={(e) => setF({...f, subject: e.target.value})}/></div>
          <div><Label>Message</Label><Textarea data-testid="contact-message" required rows={5} value={f.message} onChange={(e) => setF({...f, message: e.target.value})}/></div>
          <Button data-testid="contact-submit" type="submit" className="btn-primary rounded-full px-8 py-6">Send message</Button>
        </form>
        <div className="space-y-8">
          <div className="wood-texture p-8 rounded-lg border hairline relative overflow-hidden">
            <div className="grain absolute inset-0"/>
            <div className="relative">
              <div className="uppercase text-xs tracking-[0.3em] font-bold" style={{color: "var(--secondary)"}}>The Studio</div>
              <div className="mt-4 space-y-4">
                <a data-testid="contact-address-link" href="https://www.google.com/maps/search/?api=1&query=Jarrell%2C+TX" target="_blank" rel="noopener noreferrer" className="flex items-start gap-3 group"><MapPin size={18} strokeWidth={1.5} style={{color: "var(--secondary)"}}/><div className="text-sm group-hover:text-[color:var(--secondary)] transition-colors">Jarrell, TX</div></a>
                <a data-testid="contact-email-link" href="mailto:ez.jem.creations@gmail.com" className="flex items-center gap-3 group"><Mail size={18} strokeWidth={1.5} style={{color: "var(--secondary)"}}/><div className="text-sm group-hover:text-[color:var(--secondary)] transition-colors">ez.jem.creations@gmail.com</div></a>
                <a data-testid="contact-phone-link" href="tel:+15124260568" className="flex items-center gap-3 group"><Phone size={18} strokeWidth={1.5} style={{color: "var(--secondary)"}}/><div className="text-sm group-hover:text-[color:var(--secondary)] transition-colors">(512) 426-0568</div></a>
              </div>
            </div>
          </div>
          <div>
            <div className="uppercase text-xs tracking-[0.3em] font-bold mb-3" style={{color: "var(--secondary)"}}>Follow our work</div>
            <SocialLinks dark/>
          </div>
          <div className="text-sm text-[color:var(--text-muted)] leading-relaxed">Studio hours: Monday – Saturday, 9am – 6pm. Consultations by appointment.</div>
        </div>
      </div>
    </div>
  );
}
